<template>
	<div class="main" :style="{ '--theme-color': themeColor }">
		<div class="navbar" v-show="mobileNavbarShow">
			<el-menu :default-active="currRoute" class="el-menu-vertical" mode="vertical">
				<el-menu-item v-for="item in navItemsMobile" v-show="item.show" :key="item.index" :index="item.index"
					@click="toRouter(item.route)">
					<span>{{ item.key ? $t(item.key) : item.text }}</span>
				</el-menu-item>
			</el-menu>
		</div>
		<header class="header_pc"><img :src="gameData.logoImage" alt="" class="logo">
			<div class="switch">
				<el-menu :default-active="currRoute" mode="horizontal" class="el-menu-pc" :router="false">
					<el-menu-item index="index" @click="toRouter('/')">
						{{ $t('top_up_center_text') }}
					</el-menu-item>
					<el-menu-item v-for="item in navItemsPc" v-show="item.show" :key="item.index" :index="item.index"
						@click="toRouter(item.route)">
						<img v-if="item.icon" style="width: .375rem; height: .375rem; margin-right: .2rem;"
							:src="item.icon" alt="">
						<span>{{ item.key ? $t(item.key) : item.text }}</span>
					</el-menu-item>
				</el-menu>
			</div><button class="login bg_color" v-show="!hasLogin" v-on:click="openLoginWindow()">{{ $t('sign_in_text')
			}}</button>
			<p class="color login_out" v-on:click="loginOut()" v-show="hasLogin">{{ $t('log_out_text') }}</p>
		</header>
		<header class="header_m">
			<div v-on:click="openMobileNavbar()"><i class="fa fa-server server" style="color: rgb(112, 112, 112);"></i>
			</div><img :src="gameData.logoImage" alt="" class="logo">
			<button class="login bg_color" v-on:click="openLoginWindow()" v-show="!hasLogin">{{ $t('sign_in_text')
			}}</button>
			<p class="color login_out" v-on:click="loginOut()" v-show="hasLogin">{{ $t('log_out_text') }}</p>
		</header>
		<LoginWindow></LoginWindow>
	</div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import LoginWindow from '../components/loginWindow.vue'

let scoreLotteryEntranceVisibleCache = null;

export default {
	name: 'AppHeader',
	components: {
		LoginWindow
	},
	computed: {
		navItemsMobile() {
			return [
				{ index: 'index', route: '/', key: 'top_up_center_text', show: true },
				{ index: 'welfare', route: 'welfare', key: 'benefit_text', show: this.gameData.hasWelfare },
				{ index: 'points', route: 'points', key: 'points_text', show: this.showPoints() },
				{ index: 'limitWelfare', route: 'limitWelfare', key: 'limited_event_text', show: this.showLimitWelfare() },
				{ index: 'dailyRewards', route: 'dailyRewards', key: 'daily_rewards_text', show: this.showDailyRewards() },
				{ index: 'dailyRewardsPay', route: 'dailyRewardsPay', text: '일일 혜택', show: this.showDailyRewardsPay() },
				{ index: 'activity', route: 'activity', text: '轉盤抽獎', show: this.showActivity() },
				{ index: 'lottery', route: 'lottery', key: 'score_lottery_text', show: this.showScoreLottery() },
				{ index: 'orders', route: 'orders', key: 'orders_records_text', show: false },
				{ index: 'profile', route: 'profile', key: 'personalCenter.title', show: true }
			]
		},
		navItemsPc() {
			return [
				{ index: 'welfare', route: 'welfare', key: 'benefit_text', show: this.gameData.hasWelfare },
				{ index: 'points', route: 'points', key: 'points_text', show: this.showPoints() },
				{ index: 'limitWelfare', route: 'limitWelfare', key: 'limited_event_text', show: this.showLimitWelfare(), icon: '../assets/image/alarm1.png' },
				{ index: 'dailyRewards', route: 'dailyRewards', key: 'daily_rewards_text', show: this.showDailyRewards() },
				{ index: 'dailyRewardsPay', route: 'dailyRewardsPay', text: '일일 혜택', show: this.showDailyRewardsPay() },
				{ index: 'activity', route: 'activity', text: '轉盤抽獎', show: this.showActivity() },
				{ index: 'lottery', route: 'lottery', key: 'score_lottery_text', show: this.showScoreLottery() },
				{ index: 'orders', route: 'orders', key: 'orders_records_text', show: false },
				{ index: 'profile', route: 'profile', key: 'personalCenter.title', show: true }
			]
		},
		themeColor() {
			const code = this.gameData && this.gameData.gameCode;
			const map = {
				cztxtw: '#D26A2C',
				cztxkr: '#2563eb',
				tgfm: '#3b82f6',
				tgth: '#10b981',
				msgen: '#f59e0b',
				mym2ru: '#ef4444',
				lsqyru: '#8b5cf6',
				tgru: '#14b8a6'
			};
			return map[code] || '#D26A2C';
		}
	},
	data() {
		return {
			hasLogin: this.$session.hasLogin(),
			currRoute: this.$route.name,
			mobileNavbarShow: false,
			loginData: this.$cache.getLoginData(),
			gameData: this.$store.state.gameData,
			scoreLotteryEntranceVisible: false
		}
	},
	mounted() {
		this.importPlugin();
		this.initScoreActivityData();
	},
	methods: {
		showLimitWelfare: function () {
			return this.gameData.gameCode == 'msgen';
		},
		showPoints: function () {
			return this.gameData.gameCode == 'tgfm' || this.gameData.gameCode == 'cztxkr' || this.gameData.gameCode == 'cztxtw' ||
				this.gameData.gameCode == 'mym2ru' || this.gameData.gameCode == 'lsqyru' || this.gameData.gameCode == 'tgru'  || 
				this.gameData.gameCode == 'm2en' || this.gameData.gameCode == 'sgyjltw' || this.gameData.gameCode == 'fzsgkr' || this.gameData.gameCode == 'lycqkr';
		},
		showDailyRewards: function () {
			// return this.gameData.hasDailyRewards == true;
			return this.gameData.gameCode == 'tgth';
		},
		showDailyRewardsPay: function () {
			// return this.gameData.hasDailyRewards == true;
			return this.gameData.gameCode == 'tgfm';
		},
		showActivity: function () {
			return this.gameData.gameCode == 'cztxtw';
		},
		showScoreLottery: function () {
			const loginData = this.$cache.getLoginData() || {};
			return this.scoreLotteryEntranceVisible
		},
		importPlugin: function () {
			const script = document.createElement('script');
			script.src = '/static/js/jquery.bpopup.js';
			document.head.appendChild(script);
		},
		initScoreActivityData: async function () {
			if (scoreLotteryEntranceVisibleCache !== null) {
				this.scoreLotteryEntranceVisible = scoreLotteryEntranceVisibleCache;
				return;
			}
			try {
				const response = await this.$axios({
					method: 'get',
					url: '/web/api/scoreActivity/init-data',
					params: {
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
						gameLanguage: this.getGameLanguage()
					}
				});
				this.scoreLotteryEntranceVisible = response.code === 1000 && response.data && response.data.entranceVisible === true;
				scoreLotteryEntranceVisibleCache = this.scoreLotteryEntranceVisible;
			} catch (error) {
				this.scoreLotteryEntranceVisible = false;
				scoreLotteryEntranceVisibleCache = false;
				console.error(this.$t('score_lottery_entrance_error'), error);
			}
		},
		getGameLanguage() {
			return (this.gameData && this.gameData.language) || (this.$i18n && this.$i18n.locale) || 'en_US'
		},
		openLoginWindow: function () {
			this.$analytics.track('login_opened', { placement: 'header' });
			$("#loginWindow").bPopup();
		},
		loginOut: function () {
			this.$session.clearCookieLoginData();
			this.$cache.clearAllCacheData();
			window.location.reload();
		},
		toRouter: function (name) {
			this.$analytics.track('navigation_clicked', { destination_path: name, placement: 'header' });
			this.$router.push({
				path: name
			});
			this.mobileNavbarShow = false;
		},
		openMobileNavbar: function () {
			this.mobileNavbarShow = !this.mobileNavbarShow;
		}
	}
}
</script>

<style scoped>
::v-deep .el-menu-pc.el-menu.el-menu--horizontal {
	width: 100%;
	background-color: transparent;
	border-bottom: none;
	padding: 0;
	color: inherit;
	font-size: inherit;
	line-height: inherit;
}

::v-deep .el-menu-pc.el-menu .el-menu-item {
	display: inline-flex;
	align-items: center;
	height: auto;
	padding: .12rem .18rem;
	color: inherit;
	font-size: .25rem;
	line-height: inherit;
}

::v-deep .el-menu-pc.el-menu .el-menu-item:hover,
.el-menu-vertical.el-menu .el-menu-item:hover {
	color: var(--theme-color, #D26A2C);
	background-color: rgba(0, 0, 0, 0.04);
}

::v-deep .el-menu-pc.el-menu .el-menu-item.is-active,
.el-menu-vertical.el-menu .el-menu-item.is-active {
	color: var(--theme-color, #D26A2C);
	font-weight: 600;
}

::v-deep .el-menu-pc.el-menu.el-menu--horizontal>.el-menu-item {
	border-bottom: 2px solid transparent;
	margin-right: .28rem;
}

::v-deep .el-menu-pc.el-menu.el-menu--horizontal>.el-menu-item.is-active {
	border-bottom-color: currentColor;
}

::v-deep .el-menu-pc.el-menu.el-menu--horizontal>.el-menu-item:last-child {
	margin-right: 0;
}
</style>
